import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "container flex flex-col" }
const _hoisted_2 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-8" }
const _hoisted_3 = {
  ref: "steps",
  class: "scrollbar-hide my-8 -mx-8 flex overflow-x-auto bg-white py-8 pl-8 lg:col-span-12 lg:row-start-4 lg:m-0 lg:overflow-hidden lg:pr-8"
}
const _hoisted_4 = { class: "text-gray-400" }
const _hoisted_5 = { class: "text-lg font-bold lg:text-4xl" }
const _hoisted_6 = { class: "hidden lg:col-span-4 lg:col-start-1 lg:row-start-1 lg:block" }
const _hoisted_7 = { class: "relative h-0 w-full bg-gray-400 pt-2/3" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "absolute top-0 right-0 h-36 w-36 -translate-y-1/4 translate-x-1/2 bg-gray-500 py-10 px-5 text-sm font-medium uppercase leading-5 tracking-wider text-white lg:text-base"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 h-0.5 w-6 bg-white" }, null, -1)
const _hoisted_11 = { class: "mb-6 hidden lg:col-span-5 lg:block" }
const _hoisted_12 = { class: "text-gray-400" }
const _hoisted_13 = { class: "font-bold lg:text-4xl" }
const _hoisted_14 = ["onClick", "onMouseenter"]
const _hoisted_15 = { class: "relative pt-1/1" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "line-clamp-2" }
const _hoisted_18 = {
  key: 1,
  class: "lg:col-span-8 lg:col-start-3"
}
const _hoisted_19 = { class: "my-8 lg:col-span-5 lg:col-start-6 lg:row-start-1 lg:mt-0 lg:mb-9" }
const _hoisted_20 = { class: "text-gray-400" }
const _hoisted_21 = { class: "text-lg font-bold lg:text-4xl" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "mb-4 border-b border-gray-400/30 text-sm text-gray-400 lg:mb-5" }
const _hoisted_24 = { class: "grid grid-cols-2 gap-4 lg:grid-cols-4" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "relative h-0 pt-1/1" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "p-6" }
const _hoisted_29 = { class: "h-6 truncate uppercase tracking-wider text-gray-400" }
const _hoisted_30 = { class: "h-12 font-bold line-clamp-2 hyphens-auto" }
const _hoisted_31 = {
  key: 0,
  class: "mt-8 flex items-center"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "mr-6 h-px flex-1 bg-gray-500" }, null, -1)
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, "+", -1)
const _hoisted_35 = { class: "mb-3 mt-5 flex items-center justify-end lg:col-span-12 lg:row-start-3 lg:mt-14" }
const _hoisted_36 = {
  key: 2,
  class: "invisible h-0"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 hidden h-20 w-full bg-white lg:block" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, f) => {
            return (_openBlock(), _createElementBlock("div", {
              key: filter.filterKey,
              class: _normalizeClass(["w-1/2 flex-shrink-0 border-b-2 border-b-gray-500 pb-6 last:mr-8 lg:m-0 lg:w-auto lg:flex-1", [_ctx.step >= f ? 'border-opacity-100' : 'border-opacity-20']])
            }, [
              _createElementVNode("div", _hoisted_4, "0" + _toDisplayString(f + 1), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(filter.name), 1)
            ], 2))
          }), 128))
        ], 512),
        (_ctx.step < 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.image || _ctx.currentImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.currentImage || _ctx.image,
                        class: "absolute left-0 top-0 h-full w-full"
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.currentCategory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_ctx.currentCategory.name) + " ", 1),
                        _hoisted_10
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex flex-col justify-end lg:col-start-6 lg:row-start-1", [
                        _ctx.currentCategories.length > _ctx.CAT_GRID_LIMIT
                            ? 'lg:col-span-7'
                            : 'lg:col-span-5'
                    ]])
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, "0" + _toDisplayString(_ctx.step + 1), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.headlineLabel), 1)
                ]),
                (_ctx.currentCategories.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref: "catContainer",
                      class: _normalizeClass(["relative grid grid-cols-2 content-end gap-4 lg:h-80 lg:auto-rows-min lg:grid-cols-3 lg:gap-4", [
                            _ctx.currentCategories.length > _ctx.CAT_GRID_LIMIT ? 'lg:flex lg:flex-wrap' : ''
                        ]])
                    }, [
                      _createVNode(_TransitionGroup, {
                        mode: "out-in",
                        "enter-active-class": "duration-500 ease-out transition-transform",
                        "enter-from-class": "scale-0",
                        "enter-to-class": "scale-100",
                        "leave-active-class": "absolute opacity-0"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCategories, (category) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `po#${category.categoryKey}`,
                              onClick: ($event: any) => (_ctx.toggleCategory(category.categoryKey)),
                              onMouseenter: ($event: any) => (_ctx.hoverCategory(category)),
                              onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.blurCategory && _ctx.blurCategory(...args))),
                              style: _normalizeStyle(_ctx.gridSize),
                              class: _normalizeClass([[
                                    _ctx.isCategorySelected(category.categoryKey)
                                        ? 'bg-gray-500 text-white'
                                        : 'bg-white text-gray-400',
                                    {
                                        'lg:inline-block lg:p-2':
                                            _ctx.currentCategories.length > _ctx.CAT_GRID_LIMIT
                                    }
                                ], "cursor-pointer overflow-hidden transition-colors hover:bg-gray-500 hover:text-white"])
                            }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", {
                                  title: category.name,
                                  class: _normalizeClass([{
                                            'lg:p-1 lg:text-xs':
                                                _ctx.currentCategories.length > _ctx.CAT_GRID_LIMIT + 2
                                        }, "absolute left-0 top-0 flex h-full w-full flex-col items-center justify-center p-3 text-center text-sm hyphens-auto"])
                                }, [
                                  (category.icon)
                                    ? (_openBlock(), _createBlock(_component_biz_icon, {
                                        key: 0,
                                        name: category.icon,
                                        class: _normalizeClass([{
                                                'lg:mb-2 lg:h-6 lg:w-6':
                                                    _ctx.currentCategories.length > _ctx.CAT_GRID_LIMIT + 2
                                            }, "mb-4 h-8 w-8 shrink-0 fill-current"])
                                      }, null, 8, ["name", "class"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(category.name), 1)
                                ], 10, _hoisted_16)
                              ])
                            ], 46, _hoisted_14))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, "0" + _toDisplayString(_ctx.step + 1), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.resultsHeadlineLabel), 1)
              ]),
              (_ctx.result)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns.categories, (column) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mb-9 lg:mb-16",
                        key: column.categoryId
                      }, [
                        (
                                _ctx.result[column.categoryKey] &&
                                _ctx.result[column.categoryKey].results.length
                            )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(column.name) + " (" + _toDisplayString(_ctx.result[column.categoryKey].total) + ") ", 1),
                              _createElementVNode("div", _hoisted_24, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result[column.categoryKey].results, (product) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: product.id,
                                    href: product.link,
                                    class: "flex flex-col justify-between bg-gray-100"
                                  }, [
                                    _createElementVNode("div", _hoisted_26, [
                                      (product.image)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: product.image,
                                            alt: product.imageAlt,
                                            class: "absolute left-0 top-0 h-full w-full object-cover object-center"
                                          }, null, 8, _hoisted_27))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, _toDisplayString(product.kicker), 1),
                                      _createElementVNode("div", _hoisted_30, _toDisplayString(product.title), 1)
                                    ])
                                  ], 8, _hoisted_25))
                                }), 128))
                              ]),
                              (
                                    _ctx.result[column.categoryKey].results.length <
                                    _ctx.result[column.categoryKey].total
                                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createElementVNode("span", {
                                      onClick: ($event: any) => (_ctx.loadAll(column)),
                                      class: "cursor-pointer font-bold transition-colors hover:text-gray-400"
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.showAllLabel) + " ", 1),
                                      _hoisted_34
                                    ], 8, _hoisted_33)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", _hoisted_35, [
          (_ctx.step > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
                class: _normalizeClass(["font-bold text-gray-400 underline", [
                        _ctx.step >= 3 ? 'pl-9' : 'px-9',
                        { 'pointer-events-none opacity-50': _ctx.step === 0 }
                    ]])
              }, _toDisplayString(_ctx.backLabel), 3))
            : _createCommentVNode("", true),
          (_ctx.step < 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
                class: _normalizeClass(["button button-primary inline-flex items-center py-2.5", {
                        'pointer-events-none opacity-50':
                            _ctx.step >= _ctx.filters.length || _ctx.selectedCategories[_ctx.step].length === 0
                    }])
              }, [
                _createTextVNode(_toDisplayString(_ctx.nextLabel) + " ", 1),
                _createVNode(_component_biz_icon, {
                  name: "chevron-right",
                  class: "ml-2 h-3 w-2 fill-current"
                })
              ], 2))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.ready)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_37
  ], 64))
}